import { useAppDispatch, useAppSelector } from '@/hooks/index'
import { clearActiveFlows, setActiveFlows } from '@/reducers/activeFlowsReducer'
import {
  postMessagetoMobileIfPresent,
  SET_ACTIVE_FLOWS,
} from '@/utils/messageUtils'
import { match, P } from 'ts-pattern'

// This hook is used to allow us to head back to the start of our
// multi-program enrollment flow when adding devices through that flow
export default function useMultiProgramFlowControl() {
  const dispatch = useAppDispatch()

  const multiProgramFlowStart: string | null = useAppSelector(
    (state) => state.activeFlows?.multiProgramFlowStart,
  )

  const multiProgramFlowProgramId: number | null = useAppSelector(
    (state) => state.activeFlows?.multiProgramFlowProgramId,
  )

  const setFlowStartPoint = (pathname?: string, programId?: number) => {
    const multiProgramFlowStart = match(pathname)
      .with(P.nonNullable, (p) => p)
      .otherwise(() => location.pathname)
    const activeFlows = {
      multiProgramFlowStart,
      multiProgramFlowProgramId: programId ?? null,
    }
    dispatch(setActiveFlows(activeFlows))
    postMessagetoMobileIfPresent(JSON.stringify(activeFlows), SET_ACTIVE_FLOWS)
  }

  const clearFlow = () => {
    dispatch(clearActiveFlows())
    postMessagetoMobileIfPresent('null', SET_ACTIVE_FLOWS)
  }

  // Use this method when trying to get a flow URL, as it cleans up flow state after usage
  const popFlowUri = (fallback?: string) => {
    const uri = multiProgramFlowStart
    clearFlow()

    return uri ?? fallback ?? '/app'
  }

  return {
    flowStartUrl: multiProgramFlowStart,
    multiProgramFlowProgramId,
    setFlowStartPoint,
    popFlowUri,
    clearFlow,
    inFlow: multiProgramFlowStart !== null,
  }
}
